exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".browser[data-v-418399cc]{background-color:#fff}.important-note[data-v-418399cc]{text-transform:uppercase;text-align:center}.cbox[data-v-418399cc]{margin:0}.hidden-input-box[data-v-418399cc]{z-index:-9999}.browser-name[data-v-418399cc]{font-weight:800}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-418399cc","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Browser.vue
// module id = oVQm
// module chunks = 0